module.exports = __webpack_public_path__ + "static/img/s5.4b799fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s5.png
// module id = aEuD
// module chunks = 0